<template>
  <router-link
    :to="{ name: 'product', params: { id: product.id } }"
    class="product-tile"
  >
    <div v-if="product?.is_sale" class="product-tile__sale">
      <span v-if="product?.badge_text">{{ product?.badge_text }}</span>
      <span v-else>Ціну знижено!</span>
    </div>
    <div class="product-tile__img">
      <img :src="image" :alt="product?.name" />
    </div>
    <div class="flex-fill d-flex flex-column w-100">
      <div class="product-tile__title">
        {{ product.name }}
      </div>
      <p>{{ description }}</p>
    </div>
    <div class="product-tile__price">
      <div v-if="product.is_available">
        <div
          v-if="product.old_price"
          class="product-tile__price-old d-inline-block"
        >
          {{ product.old_price }}
          <span class="product-tile__price-old-grn">грн</span>
        </div>
        <div :class="{ 'product-tile__price-red': product.old_price }">
          {{ product.price }} грн
        </div>
      </div>
      <div v-else class="text-muted">Очікується</div>
    </div>
    <div class="product-tile__button">
      <span class="ic ic-sm ic-black ic-shop-cart"></span>
    </div>
  </router-link>
</template>

<script>
import { computed } from "vue";
import DefaultGoodsIcon from "@/assets/shop/default-goods-icon.png";
import StringMixin from "@/mixins/string.js";

export default {
  name: "ShopProductTile",
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { stripTags, stringLimit } = StringMixin.methods;

    const description = computed(() => {
      return stringLimit(stripTags(props.product.description), 60);
    });

    const image = computed(() => {
      return props.product?.images?.[0]?.url || DefaultGoodsIcon;
    });

    return {
      description,
      image,
    };
  },
};
</script>

<style lang="less" scoped>
@import "@/styles/_variables.less";

.product-tile {
  display: flex;
  width: 100%;
  position: relative;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  border-radius: 15px;
  padding: 12px;
  overflow: hidden;
  text-decoration: none;
  background: linear-gradient(180deg, #313944 0%, rgba(49, 57, 68, 0) 128.66%);
  opacity: 0.8;
  border: 1px solid rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(30px);

  @media @lg {
    padding: 15px;
  }

  &__sale {
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 15px 0;
    background: linear-gradient(109deg, #ffd159 20.34%, #ff2b2b 62.78%);
    color: #fff;
    padding: 6px 13px;
    font-size: 12px;
    font-weight: 500;
  }

  &__img {
    width: 100%;
    aspect-ratio: 1/1;
    padding: 20px;
    margin-bottom: 10px;
    border-radius: 10px;
    background: @white;
  }

  img {
    width: 100%;
    object-fit: cover;
    height: auto;
    aspect-ratio: 1/1;
  }

  &__title {
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 18px;
    color: @white;
    margin-bottom: 10px;
  }

  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 1.3;
    color: @white;
    margin-bottom: 50px;
  }

  &__price {
    position: absolute;
    bottom: 12px;
    left: 15px;
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 21px;
    color: @white;

    &-red {
      color: @red;
    }

    &-old {
      font-style: normal;
      font-weight: 400;
      font-size: 13px;
      line-height: 15px;
      color: @gray-light2;
      position: relative;

      &:after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 7px;
        width: 100%;
        height: 1px;
        background: @gray-light2;
      }

      &-grn {
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 17px;
        color: @gray-light2;
      }
    }
  }

  &__button {
    position: absolute;
    bottom: 0;
    right: 0;
    background: @yellow;
    color: @black;
    display: flex;
    justify-content: center;
    padding: 8px 10px;
    border-top-left-radius: 15px;
    font-weight: 500;

    &:hover {
      background: @yellow-hover;
    }
  }
}
</style>
